import { render } from "./ViewClient.vue?vue&type=template&id=5d50f3ff&ts=true"
import script from "./ViewClient.vue?vue&type=script&lang=ts"
export * from "./ViewClient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__